export default {
  namespaced: true,
  state: {
    isVisibleCreateFromInvoiceModal: false
  },
  getters: {
    isVisibleCreateFromInvoiceModal: state => state.isVisibleCreateFromInvoiceModal
  },
  mutations: {
    toggleCreateFromInvoiceModal (state) {
      state.isVisibleCreateFromInvoiceModal = !state.isVisibleCreateFromInvoiceModal
    },
    setCreateFromInvoiceModal (state, bool) {
      state.isVisibleCreateFromInvoiceModal = bool
    }
  },
  actions: {

  }
}
